import {AbstractControl} from '@angular/forms';
import {BACKEND_ERROR_STATUSES} from 'src/app/shared/constants/backend-error-status.constants';

export function getAuthorisationErrors(error, formControl: AbstractControl) {
  switch (error.status) {
    case BACKEND_ERROR_STATUSES.INVALID_PASSWORD:
      return formControl.setErrors({invalid: 'POPUPS.INVALID_PASSWORD'});

    case BACKEND_ERROR_STATUSES.NO_DIAGRAM_REQUEST:
      return 'TOOLBAR.AUTHORISATION_ERROR_NO_DIAGRAM_REQUEST';

    case BACKEND_ERROR_STATUSES.TASK_ALREADY_CLOSED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_ALREADY_CLOSED';

    case BACKEND_ERROR_STATUSES.TASK_CANCELED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_CANCELED';

    case BACKEND_ERROR_STATUSES.TASK_REJECTED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_REJECTED';

    case BACKEND_ERROR_STATUSES.REQUEST_CLOSED:
      return 'TOOLBAR.AUTHORISATION_ERROR_REQUEST_CLOSED';

    case BACKEND_ERROR_STATUSES.TASK_COMPLETED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_COMPLETED';

    case BACKEND_ERROR_STATUSES.TASK_ALREADY_REJECTED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_ALREADY_REJECTED';

    case BACKEND_ERROR_STATUSES.TASK_APPROVED:
      return 'TOOLBAR.AUTHORISATION_ERROR_TASK_APPROVED';

    default:
      return error.error;
  }
}
